<script setup lang="ts">
import { useProductStore } from '~/store/product/productStore';

const props = defineProps<{
  selectedTab: string
}>()

const {
  selectedTab,
} = toRefs(props)

const productStore = useProductStore();
const {
  product,
} = storeToRefs(productStore);

const currentTab = product.value.description.length >= 100 ? ref('description') : ref('caracteristics');
const productContent = ref();

watch(selectedTab, (value: string) => {
  setCurrentTab(value);
});

const setCurrentTab = (value = 'description') => {
  currentTab.value = value
  productContent.value.scrollIntoView({ behavior: "smooth" });
}

const {t} = useI18n();

const els = computed(() => {
  const arr = [];


  if (product.value.description.length >= 100) {
    arr.push({
      name: 'description',
      title: t(`www.global.description`),
      display: product.value.description.length >= 100
    });
  }

  if (product.value.characteristics.length > 3 || product.value.description.length < 100) {
    arr.push({
      name: 'caracteristics',
      title: t('www.product.characteristic'),
      display: product.value.characteristics.length > 3 || product.value.description.length < 100,
    });
  }

  if (product.value.productBlockCollection && product.value.productBlockCollection.length > 0) {
    arr.push({
      name: 'specificities',
      title: t('www.extra_block.title'),
      display: product.value.productBlockCollection && product.value.productBlockCollection.length > 0,
    })
  }

  arr.push({
    name: 'return',
    title: t('www.partials.return_conditions'),
    display: true,
  });

  if (product.value.productReviewDTO?.latestReviews.length > 0) {
    arr.push({
      name: 'reviews',
      title: t('www.partials.truspilot_widget.reviews'),
      display: product.value.productReviewDTO?.latestReviews.length > 0,
    })
  }

  return arr;
});

const headers = ref([]);
const contents = ref([]);

const rearrangeElements = () => {
  if (window.innerWidth <= 768 && headers.value.length > 0) {
    headers.value.forEach((header, index) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      header.parentElement.appendChild(contents.value[index])
    });
  }
}

onMounted(() => {
  rearrangeElements()
})
</script>

<template>
  <div ref="productContent" class="df fdc product-page__content-container">
    <div class="ctabs mb-1 mt-1">
      <div class="ctabs__header">
        <div
            v-for="(el, index) in els"
            :key="index"
            @click="() => setCurrentTab(el.name)">
          <div
               v-if="el.display"
               ref="headers"
               :class="`ctabs__header-item ${currentTab === el.name ? 'ctabs__header-item--active' : ''}`"
               data-tclz-selector="header-tabs"
               data-tclz-label="Homme/Running/Chaussures/Route"
               data-tclz-category="product"
               :data-tclz-action="`click on ${el.name} deploy`">
            <h2 class="pe-n">{{ el.title }} <span v-if="el.name === 'reviews'">({{product.productReviewDTO?.globalRateCount}})</span></h2>
            <svg class="cicon mr-1 cicon--bold visible-mobile">
              <use xlink:href="#bottom-v2"/>
            </svg>
          </div>
        </div>
      </div>
      <div
          v-for="(el, index) in els"
          :key="index"
          ref="contents"
          :class="`ctabs__content ${currentTab === el.name ? 'ctabs__content--active' : ''}`">
        <product-description
                             v-if="el.name === 'description'"
                             :category-path="product.categoryPath"
                             :description="product.description"
                             :canonical-product-id="product.id"
                             :criterion-values="product.characteristics"
                             :tags="product.tags" />
        <product-caracteristics
                                v-if="el.name === 'caracteristics'"
                                :canonical-product-id="product.id"
                                :criterion-values="product.characteristics" />
        <product-specificities
                               v-if="el.name === 'specificities' && product.productBlockCollection && product.productBlockCollection.length > 0"
                               :product-block-collection="product.productBlockCollection" />
        <product-returns v-if="el.name === 'return'"/>
        <product-reviews
                         v-if="el.name === 'reviews' && product.productReviewDTO?.latestReviews"
                         :latest-reviews="product.productReviewDTO?.latestReviews"
                         :global-rate-count="product.productReviewDTO.globalRateCount"/>
      </div>
    </div>
  </div>
</template>
